export default __webpack_public_path__ + "static/media/three-dots-icon.811d841f.svg";